export { default } from './nps';
